import { defineTable, Schema } from 'squid';
export const carrierTable = defineTable('carrier', {
    id: Schema.String,
    name: Schema.String,
    office: Schema.nullable(Schema.String),
});
